import BatchDescription from "./BatchDescription"

export default BatchDescription
